import {FC} from "react";
import styled from "styled-components";
import {ModelInformFragment} from "./__generated__/ModelInform.fragment.generated";

const Container = styled.div`
  padding: 2.4rem;
  line-height: 130%;
  margin-top: -2.4rem;
  margin-left: -2.4rem;
  background: #e6ebef;
  margin-bottom: 2.5rem;
  width: calc(100% + 4.8rem);
`;

interface ModelInformProps {
  info: ModelInformFragment;
}

const ModelInform:FC<ModelInformProps> = ({ info }) => {
  return (
    <Container>
      <p>Информация о модели:</p>
      <h2>{info.name}</h2>
      <p>Url: {info.url}</p>
    </Container>
  )
}

export default ModelInform;
